import $ from 'jquery';


import './../../scss/blocks/block-section2.scss';


$(document).ready(function() {
  
    $(window).on('scroll resize',function(){
      if ($('.block-section2-section-wrap').isInViewport()) {
        
        if ($(window).width() > 992) {
          var parallaxElement = $('.block-section2-section-wrap .gallery-wrap'),
          parallaxQuantity = parallaxElement.length;
          window.requestAnimationFrame(function() {
            for (var i = 0; i < parallaxQuantity; i++) {
              var currentElement = parallaxElement.eq(i),
                windowTop = $(window).scrollTop(),
                elementTop = currentElement.offset().top,
                elementHeight = currentElement.height(),
                viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
                scrolled = windowTop - elementTop + viewPortHeight;
              currentElement.css({
                transform: "translate3d(0," + scrolled * -0.20 + "px, 0)"
              });
            }
          });  
        }
        
      }
    })
  
  });
  
  
  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
  
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
  
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };